import HeadphonesOutline from './HeadphonesOutline'

export default HeadphonesOutline
// eslint-disable-next-line import/export
export * from './HeadphonesOutline'
